import AppLink from '../../../routing/helpers/AppLink';
import colors from '../../../constants/colors';

const Paginator = (props) => {
  const {
    pagination,
    route,
    params,
  } = props;

  return (
    <nav>
      <ul
        className="pagination"
        style={{
          justifyContent: 'center',
          marginBottom: '4px',
        }}
      >
        <li className="page-item">
          <AppLink
            path={route}
            params={{
              ...params,
              page: pagination.first,
            }}
            className="page-link"
          >
            <span>&laquo;</span>
          </AppLink>
        </li>
        {pagination.pagesInRange.map((p) => (
          <li key={p} className={`page-item ${pagination.current === p && 'active'}`}>
            <AppLink
              path={route}
              params={{
                ...params,
                page: p,
              }}
              className="page-link"
            >
              {p}
            </AppLink>
          </li>
        ))}
        <li className="page-item">
          <AppLink
            path={route}
            params={{
              ...params,
              page: pagination.last,
            }}
            className="page-link"
          >
            <span>&raquo;</span>
          </AppLink>
        </li>
      </ul>
      <p style={{
        fontSize: '10px',
        textAlign: 'center',
        marginBottom: '20px',
        color: colors.grey500,
      }}
      >
        Mostrando
        resultados
        {' '}
        <b>{pagination.firstItemNumber}</b>
        {' '}
        al
        {' '}
        <b>{pagination.lastItemNumber}</b>
        {' '}
        de
        {' '}
        <b>{pagination.totalCount}</b>
      </p>
    </nav>
  );
};

export default Paginator;
